import { ViewContainerRef } from '@angular/core';
import { ModuleHostComponent } from '../components/module-host/module-host.component';

export class ModuleHost  {
  name: string = '';
  moduleHost: ModuleHostComponent;
  viewContainerRef: ViewContainerRef;
}
